import { Box, Button, Typography } from '@mui/material';

import {
  FSPL_ONELINE_DESCRIPTION,
  FSPL_SHORT_DESCRIPTION,
} from '../../../constants/strings';

import MaxWidthContainer from '../../shared/max-width-containe/max-width-container.component';
import PortfolioCarousel from '../../shared/portfolio-carousel/portfolio-carousel.component';
import Highlight from './highlight/highlight.component';

import { useAboutSectionStyles } from './about.styles';

const AboutSection = () => {
  const classes = useAboutSectionStyles();

  return (
    <Box
      component='section'
      sx={{
        background: 'white',
        padding: '120px 0',
        '@media (max-width: 1024px)': { padding: '60px 0' },
      }}
    >
      <MaxWidthContainer>
        <PortfolioCarousel />
        <Box className={classes.aboutWrapper}>
          <Box>
            <Typography className={classes.dHeading}>
              {FSPL_ONELINE_DESCRIPTION}
            </Typography>
            <Typography className={classes.dSummary}>
              {FSPL_SHORT_DESCRIPTION}
            </Typography>
            <Button variant='contained'>Read More</Button>
          </Box>
          <Box className={classes.highlights}>
            <Highlight number={400} highlightText='Stories' />
            <Highlight number={100} highlightText='Projects' />
            <Highlight number={50} highlightText='Clients' />
          </Box>
        </Box>
      </MaxWidthContainer>
    </Box>
  );
};

export default AboutSection;
